import * as React from "react";
import type { QueryAttributeDefinition } from "../../types.js";
import { AttributeSelectionControl } from "./AttributeSelectionControl.js";
import { EntityNodeControl } from "./EntityNodeControl.js";

export interface EntityQueryNodeControlProps {
  title: React.ReactNode;
  titleLeading?: React.ReactNode;
  titleActions?: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  children?: React.ReactNode;
  beforeAttributes?: React.ReactNode;
  attributes: QueryAttributeDefinition[];
  selectedAttributes: string[];
  onToggleAttribute: (attributeName: string, checked: boolean) => void;
  attributePlaceholder: string;
  showQuickRemoveAttributes?: boolean;
  showAttributes?: boolean;
  collapsible?: boolean;
  defaultExpanded?: boolean;
}

export function EntityQueryNodeControl({
  title,
  titleLeading,
  titleActions,
  subtitle,
  actions,
  children,
  beforeAttributes,
  attributes,
  selectedAttributes,
  onToggleAttribute,
  attributePlaceholder,
  showQuickRemoveAttributes = false,
  showAttributes = true,
  collapsible = false,
  defaultExpanded = true,
}: EntityQueryNodeControlProps): JSX.Element {
  return (
    <EntityNodeControl
      title={title}
      titleLeading={titleLeading}
      titleActions={titleActions}
      subtitle={subtitle}
      actions={actions}
      collapsible={collapsible}
      defaultExpanded={defaultExpanded}
    >
      {beforeAttributes}

      {showAttributes ? (
        <AttributeSelectionControl
          attributes={attributes}
          selectedAttributes={selectedAttributes}
          onToggleAttribute={onToggleAttribute}
          placeholder={attributePlaceholder}
          showQuickRemove={showQuickRemoveAttributes}
        />
      ) : null}

      {children}
    </EntityNodeControl>
  );
}